import { SET_ORDER_HISTORY } from './constants';

export const setOrderHistory = locations => {
    return {
        type: SET_ORDER_HISTORY,
        payload: locations,
    };
};
